import { useEffect } from "react";

import { getAbFlags } from "config/ab";
import { SHOW_DEBUG_VALUES_KEY } from "config/localStorage";
import { getIsLargeAccount } from "domain/stats/isLargeAccount";
import { API_UI_FLAGS, useIsApiSdkEnabled } from "domain/synthetics/uiFlags/useIsApiSdkEnabled";
import { useChainId } from "lib/chains";
import { useLocalStorageSerializeKey } from "lib/localStorage";
import { useOracleKeeperFetcher } from "lib/oracleKeeperFetcher";
import { useBowser } from "lib/useBowser";
import useIsWindowVisible from "lib/useIsWindowVisible";
import useIsMetamaskMobile, { getIsMobileUserAgent } from "lib/wallets/useIsMetamaskMobile";
import useWallet from "lib/wallets/useWallet";

import { isHomeSite } from "../legacy";
import { metrics } from "./Metrics";

export function useConfigureMetrics() {
  const { chainId, srcChainId } = useChainId();
  const fetcher = useOracleKeeperFetcher(chainId);
  const { active } = useWallet();
  const [showDebugValues] = useLocalStorageSerializeKey(SHOW_DEBUG_VALUES_KEY, false);
  const isMobileMetamask = useIsMetamaskMobile();
  const isWindowVisible = useIsWindowVisible();
  const isLargeAccount = getIsLargeAccount();
  const { data: bowser } = useBowser();
  const apiSdkMarkets = useIsApiSdkEnabled(API_UI_FLAGS.markets);
  const apiSdkPositions = useIsApiSdkEnabled(API_UI_FLAGS.positions);
  const apiSdkOrders = useIsApiSdkEnabled(API_UI_FLAGS.orders);

  useEffect(() => {
    metrics.subscribeToEvents();
    return () => {
      metrics.unsubscribeFromEvents();
    };
  }, []);

  useEffect(() => {
    metrics.setFetcher(fetcher);
  }, [fetcher]);

  useEffect(() => {
    metrics.setDebug(showDebugValues || false);
  }, [showDebugValues]);

  useEffect(() => {
    metrics.setGlobalMetricData({
      isMobileMetamask,
      isWindowVisible,
      isAuthorised: active,
      abFlags: getAbFlags(),
      apiSdkMarkets,
      apiSdkPositions,
      apiSdkOrders,
      isMobile: getIsMobileUserAgent(),
      isHomeSite: isHomeSite(),
      isLargeAccount,
      browserName: bowser?.browser.name,
      browserVersion: bowser?.browser.version,
      platform: bowser?.platform.type,
      isInited: Boolean(bowser),
      srcChainId,
    });
  }, [
    active,
    isMobileMetamask,
    isWindowVisible,
    isLargeAccount,
    bowser,
    srcChainId,
    apiSdkMarkets,
    apiSdkPositions,
    apiSdkOrders,
  ]);

  useEffect(() => {
    metrics.updateWalletNames();
  }, [active]);
}
